module.exports = __webpack_public_path__ + "img/menu.fb057031.svg";